import { navigation } from '@ecosystem/newron-design-system';
import React, { FC } from 'react';

import { Tab } from '../types';

const { SideNavigationItem } = navigation;

interface ContextNavigationProps {
  tabs: Tab[];
  selectedTab: Tab;
  onTabChange: (tab: Tab) => void;
}

export const ContextNavigation: FC<ContextNavigationProps> = ({ tabs, selectedTab, onTabChange }) => (
  <SideNavigationItem sideNavItems={tabs} defaultSelectedItem={selectedTab} onItemClick={onTabChange} />
);
